import { useNumericParams } from '@domain-group/react-hooks'

import useReduxAction from '@hooks/useReduxAction'

import defaultRequestOptions from '@sections/Admin/packs/SystemManager/defaultRequestOptions'

import AgencyEditRoutes from './routes'

const AgencyEdit = () => {
  const { agencyId } = useNumericParams()

  useReduxAction(
    'agencies',
    'loadAgency',
    {
      entityId: agencyId,
      ...defaultRequestOptions.agency,
      ...defaultRequestOptions.brand,
      ...defaultRequestOptions.image,
    },
    [agencyId],
    {
      dispatchAction: (action, requestOptions) => action(agencyId, requestOptions),
      // @ts-expect-error TS2322
      shouldPerformFn: ({ loading }) => agencyId && !loading,
    },
  )

  return (
    <AgencyEditRoutes />
  )
}

export default AgencyEdit
